import React from 'react';
import Icon from 'components/blocks/Icon/Icon';
import IconEspecialidad from '../../../img/icons/svg/cita/especialidad-azul.svg?react';
import IconEstado from '../../../img/icons/svg/cita/estado-azul.svg?react';

export interface IDeltaCard {
  id: string;
  icon: 'especialidad' | 'estado';
  tone: 'teal' | 'navy';
  title: string;
  subtitle: string;
  desc: string;
  status: string;
  urgent: boolean;
  pathTo: string;
}

export interface IDeltaGroup {
  id: string;
  label: string;
  eyebrow: string;
  tone: string;
  cards: IDeltaCard[];
}

export const deltaGroups: IDeltaGroup[] = [
  {
    id: 'con-baja',
    label: 'Con Baja',
    eyebrow: 'Accidentes laborales con baja médica',
    tone: 'warn',
    cards: [
      {
        id: 'con-baja-pend',
        icon: 'especialidad',
        tone: 'teal',
        title: 'Accidentes con baja',
        subtitle: 'Pendientes DELT@',
        desc: 'Partes de accidente con baja médica pendientes de comunicar al sistema DELT@.',
        status: 'Pendiente',
        urgent: true,
        pathTo: '/unidad-delta/accidentes-con-baja-pendientes-de-delta',
      },
      {
        id: 'con-baja-rem',
        icon: 'estado',
        tone: 'navy',
        title: 'Accidentes con baja',
        subtitle: 'DELT@ remesados',
        desc: 'Partes con baja médica ya enviados al sistema DELT@ y procesados.',
        status: 'Remesados',
        urgent: false,
        pathTo: '/unidad-delta/accidentes-con-baja-delta-remesados',
      },
    ],
  },
  {
    id: 'sin-baja',
    label: 'Sin Baja',
    eyebrow: 'Accidentes laborales sin baja médica',
    tone: 'teal',
    cards: [
      {
        id: 'sin-baja-pend',
        icon: 'especialidad',
        tone: 'teal',
        title: 'Accidentes sin baja',
        subtitle: 'Pendientes DELT@',
        desc: 'Partes de accidente sin baja médica pendientes de comunicar al sistema DELT@.',
        status: 'Pendiente',
        urgent: true,
        pathTo: '/unidad-delta/accidentes-sin-baja-pendientes-delta',
      },
      {
        id: 'sin-baja-rem',
        icon: 'estado',
        tone: 'navy',
        title: 'Accidentes sin baja',
        subtitle: 'DELT@ remesados',
        desc: 'Partes sin baja médica ya enviados al sistema DELT@ y procesados.',
        status: 'Remesados',
        urgent: false,
        pathTo: '/unidad-delta/accidentes-sin-baja-delta-remesados',
      },
    ],
  },
];

interface DeltaCardProps {
  card: IDeltaCard;
  onNavigate: (path: string) => void;
}

const DeltaCard: React.FC<DeltaCardProps> = ({ card: c, onNavigate }) => (
  <a
    href="#"
    onClick={(e) => { e.preventDefault(); onNavigate(c.pathTo); }}
    className={`delta-card delta-card--${c.tone}${c.urgent ? ' delta-card--urgent' : ''}`}
  >
    <div className="delta-card__icon" aria-hidden="true">
      {c.icon === 'especialidad'
        ? <IconEspecialidad width={30} height={30} />
        : <IconEstado width={30} height={30} />
      }
    </div>

    <div className="delta-card__body">
      <div className="delta-card__title">
        {c.title} <strong>{c.subtitle}</strong>
      </div>
      <div className="delta-card__desc">{c.desc}</div>
      <div className="delta-card__meta">
        <span className={`delta-card__pill delta-card__pill--${c.urgent ? 'warn' : 'ok'}`}>
          {c.urgent ? (
            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          )}
          {c.status}
        </span>
      </div>
    </div>

    <span className="delta-card__chev" aria-hidden="true">
      <Icon name="arrow-right" size={20} />
    </span>
  </a>
);

export default DeltaCard;
